import { type ReactNode } from 'react'
import { cn } from '../../helpers/classnames'

export interface JosefBoxProps {
  children: ReactNode
  className?: string
}

export function JosefBox({
  children,
  className = '',
}: JosefBoxProps) {
  return (
    <div className={cn('rounded-lg overflow-hidden', className)}>
      {children}
    </div>
  )
}

export default JosefBox